/*jshint unused:false*/
/* global jQuery, $ */
/* global sunriseGlobal, SwipeContent */

/*$(document).one('focus.auto-expand', 'textarea.auto-expand', function() {
	var savedValue = this.value;
	this.value = '';
	this.baseScrollHeight = this.scrollHeight;
	this.value = savedValue;
}).on('input.auto-expand', 'textarea.auto-expand', function() {
	var minRows = this.getAttribute('data-min-rows')|0, rows;
	this.rows = minRows;
	rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 16);
	this.rows = minRows + rows;
});*/

$(document).on('input.auto-expand', 'textarea.auto-expand', function (field) {
	field = field.target;
	// Reset field height
	field.style.height = 'inherit';

	// Get the computed styles for the element
	var computed = window.getComputedStyle(field);

	// Calculate the height
	var height =
		parseInt(computed.getPropertyValue('border-top-width'), 10) +
		parseInt(computed.getPropertyValue('padding-top'), 10) +
		field.scrollHeight +
		parseInt(computed.getPropertyValue('padding-bottom'), 10) +
		parseInt(computed.getPropertyValue('border-bottom-width'), 10);

	field.style.height = height + 'px';
});

/*var autoExpand = function (field) {
	// Reset field height
	field.style.height = 'inherit';

	// Get the computed styles for the element
	var computed = window.getComputedStyle(field);

	// Calculate the height
	var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
	             + parseInt(computed.getPropertyValue('padding-top'), 10)
	             + field.scrollHeight
	             + parseInt(computed.getPropertyValue('padding-bottom'), 10)
	             + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

	field.style.height = height + 'px';
};*/

$(document).ready(function () {
	function validateForm(content) {
		var passed = true;
		$(content)
			.find('input, textarea')
			.each(function () {
				var col = $(this).parent(),
					valid = true,
					val = $(this)
						.val()
						.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''),
					reg = '';

				if (
					$(this).attr('type') === 'radio' ||
					$(this).attr('type') === 'checkbox'
				) {
					if (
						$(
							'input[name="' +
								$(this).attr('name') +
								'"]:checked',
						).val() === undefined
					) {
						valid = false;
					}
				} else {
					var pattern = $(col).attr('data-pattern');
					if (pattern) {
						reg = new RegExp(pattern);
					} else if ($(this).attr('type') === 'number') {
						reg = new RegExp(/^[0-9]{1,}$/);
					} else if ($(this).attr('type') === 'email') {
						reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
					} else {
						valid = !val ? false : true;
					}
					if (reg && !reg.test(val)) {
						valid = false;
					}
				}

				if (!valid) {
					passed = false;
					$(col).addClass('error');
					liveValidateField(this, content);
				} else {
					$(col).removeClass('valid');
				}
			});

		return passed;
	}

	function liveValidateField(field, context) {
		// Live validate fields after validation error
		$(field).off('keyup change');
		$(field).on('keyup change', function () {
			$(context).toggleClass('error', !validateForm(context));
			$(context).toggleClass('valid', validateForm(context));
		});
	}

	/**the
	 * Form submission
	 */
	$('form .button').on('click', function () {
		// console.log('Button clicked'); // For debugging purposes
		if (
			$(this).hasClass('loading') ||
			$(this).attr('id') === 'getMaterials'
		) {
			return false;
		}
		if ($(this).attr('id') === 'downloadDocs') {
			return true;
		}

		var btn = this,
			block =
				$(this).closest('.block').hasClass('newsletter') ?
					'newsletterSignup'
				:	'contactForm',
			valError = false,
			form = $(this).closest('form'),
			formMessage = $(form).find('.form-message'),
			postRequestData = { action: block },
			emailVal = /^\S+@\S+\.\S+$/;

		$(formMessage).removeClass('show');

		$(form)
			.find('textarea, input')
			.each(function () {
				if ($(this).attr('name') === 'website_firstname') {
					if ($(this).val() !== '') {
						postRequestData[$(this).attr('name')] = $(this).val();
					}
					return true;
				}
				if (
					$(this).val() === '' ||
					($(this).attr('type') === 'email' &&
						!emailVal.test($(this).val()))
				) {
					$(this).parent().addClass('error');
					valError = true;
					liveValidateField($(this), $(this).parent());
				} else if (
					$(this).attr('type') === 'radio' &&
					!form.find(
						'input[name="' + $(this).attr('name') + '"]:checked',
					).length
				) {
					form.find('input[name="' + $(this).attr('name') + '"]')
						.parent()
						.addClass('error');
				} else {
					$(this).parent().removeClass('error').addClass('valid');
				}
				// Skip radio buttons and checkboxes if they are not checked
				if (
					($(this).attr('type') === 'radio' ||
						$(this).attr('type') === 'checkbox') &&
					!$(this).prop('checked')
				) {
					return true;
				}
				postRequestData[$(this).attr('name')] = $(this).val();
			});

		if (valError) {
			$(formMessage)
				.addClass('error show')
				.html(sunriseGlobal.validationError);
		} else {
			$(btn).addClass('loading');
			$.ajax({
				type: 'POST',
				url: sunriseGlobal.ajaxurl,
				data: postRequestData,
				success: function (data) {
					$(btn).removeClass('loading');
					data = JSON.parse(data);
					if (block === 'contactForm') {
						if (data.status === 'success') {
							$(form).find('.field, .button').hide();
							$(form)
								.find(
									'textarea, input:not([type="hidden"], [type="checkbox"])',
								)
								.val('');
							$(form)
								.find('input[type="checkbox"]')
								.prop('checked', false);
							$(form).find('.valid').removeClass('valid');
							$(form).find('.error').removeClass('error');
							$(formMessage)
								.addClass('show')
								.html(sunriseGlobal.successMsg);
						} else {
							for (let i in data.failed) {
								let field = form.find(
										'[name="' + data.failed[i] + '"]',
									),
									col = field.parent();

								col.addClass('error');
								liveValidateField(field, col);
							}
							$(formMessage)
								.addClass('error show')
								.html(sunriseGlobal.validationError);
						}
					} else {
						if (data.status === 'success') {
							$(form).find('.field, .button').hide();
							$(form)
								.find(
									'textarea, input:not([type="hidden"], [type="checkbox"])',
								)
								.val('');
							$(form)
								.find('input[type="checkbox"]')
								.prop('checked', false);
							$(form).find('.valid').removeClass('valid');
							$(form).find('.error').removeClass('error');
							$(formMessage)
								.removeClass('error')
								.addClass('show')
								.html(data.message);
						} else {
							for (let i in data.failed) {
								let field = form.find(
										'[name="' + data.failed[i] + '"]',
									),
									col = field.parent();

								col.addClass('error');
								liveValidateField(field, col);
							}
							$(formMessage)
								.addClass('error show')
								.html(data.message);
						}
					}
				},
				// jQuery calls this with (jqXHR, textStatus, errorThrown) — naming the
				// first argument errorThrown printed the jqXHR object as [object Object].
				error: function (jqXHR, textStatus, errorThrown) {
					$(btn).removeClass('loading');
					$(formMessage)
						.addClass('error show')
						.html(
							'<p><strong>' +
								(errorThrown || textStatus || 'Request failed') +
								'</strong></p>',
						);
				},
			});
		}

		return false;
	});

	/**
	 * Download form
	 */
	$('body').on('click', '#getMaterials', function (e) {
		e.preventDefault();

		var form = $(this).closest('form'),
			formMessage = $(form).find('.form-message'),
			button = $(this),
			data = {};

		button.addClass('loading');
		form.find('.error-message').html('');
		form.find('label.error').removeClass('error');

		data.action = 'getMaterials';
		data.inputs = form.serialize();
		data.downloads = [];
		$('.doc-picker .item.active').each(function (i) {
			data.downloads[i] = $(this).attr('data-file');
		});

		$.post(sunriseGlobal.ajaxurl, data).done(function (response) {
			var responseData = JSON.parse(response);
			button.removeClass('loading');

			if (responseData.status === 'success') {
				$(form)
					.find('textarea, input:not([type="hidden"], [type="checkbox"])')
					.val('');
				$(form).find('input[type="checkbox"]').prop('checked', false);
				$(form).find('.valid').removeClass('valid');
				$(formMessage)
					.removeClass('error')
					.addClass('show')
					.html('<p>' + responseData.message + '</p>');
			} else {
				if (typeof responseData.failed !== 'undefined') {
					for (var i in responseData.failed) {
						var field = form.find(
								'input[name="' + responseData.failed[i] + '"]',
							),
							col = field.parent();

						col.addClass('error');
						liveValidateField(field, col);
					}
				}
				$(formMessage)
					.addClass('error show')
					.html(
						'<p><strong>' + responseData.message + '</strong></p>',
					);
			}
		});

		return false;
	});

	/**
	 * Lightbox
	 */
	$('body').on('click', '.lightbox', function (e) {
		e.preventDefault();

		$('#lightbox').addClass('loading');

		var id = $(this).attr('data-id'),
			file = $(this).attr('data-file'),
			size = $(this).attr('data-size') || 'medium',
			content = $(this).attr('data-content'),
			async = false;

		if (content) {
			content = decodeURIComponent(content).replace(/\+/g, ' ');
			$('#lightboxContent')
				.addClass(size)
				.html('<div id="lbTextContent">' + content + '</div>');
			$('#lightbox').removeClass('loading');
		}

		if (id) {
			var elm = $('#' + id),
				callback = elm.attr('data-callback') || null;

			$('#lightboxContent')
				.addClass(size)
				.html(
					'<div id="lbTextContent">' + $('#' + id).html() + '</div>',
				);
			if (callback) {
				window[callback](arguments);
				$('#lightbox').removeClass('loading');
			} else {
				$('#lightbox').removeClass('loading');
			}
		}

		if (file) {
			$('body').on(
				'click',
				'#lightboxContent .doc-picker .item',
				function () {
					$(this).toggleClass('active');
				},
			);

			$('#lightboxContent')
				.find('.doc-picker .item[data-file="' + file + '"]')
				.trigger('click');
		}

		var doLightbox = function () {
			$('#lightbox').addClass('open');
			$('#lightboxContent').prepend(
				'<a href="javascript:void(0);" class="lightboxClose close"></a>',
			);
			window.setTimeout(function () {
				$('body').addClass('lightboxOpen');
				$('html').addClass('noScroll');
			}, 150);
		};
		if (!async) {
			doLightbox();
		}

		disableBodyScroll(true, '#lbTextContent');

		return false;
	});
	$('body').on('click', '#lightboxBg, .lightboxClose', function (e) {
		e.preventDefault();
		closeLightbox();

		return false;
	});

	// Setup lightbox open functionality based on query parameter
	var urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('id')) {
		var fileId = urlParams.get('id');
		$('.lightbox[data-file="' + fileId + '"]').trigger('click');
	}

	/*function openLightbox(content, size) {
        size = size || 'auto';

        $('#lightboxContent').addClass(size).html('<div id="lbTextContent">' + content + '</div>');

        positionLightbox();

        $('#lightbox').addClass('open');
        //$('#lightboxContent').prepend('<button class="lightboxClose"></button>');
        window.setTimeout(function() {
            $('body').addClass('lightboxOpen');
            $('html').addClass('noScroll');
        }, 150);

        disableBodyScroll(true, '#lbTextContent');
    }*/

	function closeLightbox() {
		$('body').removeClass('lightboxOpen');
		$('html').removeClass('noScroll');
		$('#lightbox').removeClass('open full big medium small');
		if ($('#lightboxContent .doc-picker .item').length) {
			$('body').off('click', '#lightboxContent .doc-picker .item');
		}
		$('#lightboxContent').attr('class', '').attr('style', '').html('');

		disableBodyScroll(false, '#lbTextContent');
	}


	/**
	 * Load more
	 */
	$('body').on('click', '.load-more', function () {
		var parent = $(this).closest('.block.gates'),
			num = parent.attr('data-num'),
			max = parent.attr('data-max');

		$('.gate.hide').each(function () {
			if (num === 0) {
				return false;
			}

			$(this).removeClass('hide');

			num--;
		});

		if ($(parent).find('.gate:not(.hide)').length == max) {
			$(this).closest('.row').fadeOut(100);
		}
	});

	/**
	 * Map hotspots
	 */
	$('body').on('click', '.hotspot', function () {
		$('body').addClass('mapModalOpened');
		var hs = this,
			modal = $(this).parent().find('.mapModal');

		modal.removeClass('show');
		$(this).parent().find('.hotspot').removeClass('active');
		$(hs).addClass('active');
		var header = $(hs).attr('data-header'),
			text = $(hs).attr('data-text'),
			image = $(hs).attr('data-image');

		modal.html(
			'<div class="mapClose close"></div>' +
				(image ?
					'<div class="image cover" style="background-image:url(' +
					image +
					');"></div>'
				:	'') +
				'<div class="text"><h5>' +
				header +
				'</h5>' +
				(text ? '<p>' + text + '</p>' : '') +
				'</div>',
		);

		placeMapModal(hs, true);

		modal.addClass('show');

		$(window).on('resize', function () {
			placeMapModal(hs);
		});

		window.setTimeout(function () {
			$('body').removeClass('mapModalOpened');
		}, 100);
	});
	$('body').on('click', '.mapClose', function () {
		$(this).parent().removeClass('show');
		$(this).closest('.hotspots').find('.hotspot').removeClass('active');
		$('body').removeClass('mapModalOpened');
	});
	$('body').on('click', function () {
		if (
			!$('body').hasClass('mapModalOpened') &&
			$('.mapModal.show').length
		) {
			$('.mapClose').trigger('click');
		}
	});

	function placeMapModal(hotspot, force) {
		force = force || false;
		var mm = $(hotspot).parent().find('.mapModal');

		if (mm.hasClass('show') || force) {
			var mWidth = $(mm).outerWidth();
			mm.css({
				top: $(hotspot).attr('data-top'),
				left: $(hotspot).attr('data-left'),
			});

			if (mm.offset().left + mWidth > $(window).outerWidth()) {
				mm.css(
					'left',
					$(hotspot).position().left +
						$(hotspot).outerWidth() -
						mWidth +
						12.5,
				);

				if (mm.offset().left < 0) {
					mm.css({ left: 0, right: 0 });
				}
			}
		}
	}

	/**
	 * Accordion
	 */
	$('.accordion').on('click', '.acc-title', function () {
		$(this).parent().toggleClass('open');
	});

	/**
	 * Timeline
	 */
	$('.timeline').each(function () {
		var tl = $(this),
			nav = tl.find('.item-nav');

		tl.on('click', '.item', function () {
			tl.find('.item').removeClass('active');
			$(this).toggleClass('active');
			tl.find('.items').css('transform', 'translateX(-350px)');
		});
		tl.find('.item').first().addClass('active');

		nav.find('.nav').on('click', function () {
			var dir = $(this).hasClass('prev') ? 'prev' : 'next',
				active = tl.find('.item.active'),
				numItems = tl.find('.item').length,
				newActive;

			active.removeClass('active');
			if (dir == 'next') {
				newActive =
					active.index() < numItems - 1 ?
						active.next()
					:	tl.find('.item').first();
			} else {
				newActive =
					active.index() > 0 ?
						active.prev()
					:	tl.find('.item').last();
			}
			newActive.addClass('active');

			if (
				tl.find('.item-row').outerWidth() <
				newActive.position().left + newActive.outerWidth()
			) {
				tl.find('.items').css(
					'transform',
					'translateX(' +
						(tl.find('.item-row').outerWidth() -
							newActive.position().left -
							newActive.outerWidth()) +
						'px)',
				);
			} else if (newActive.offset().left < 0) {
				tl.find('.items').css('transform', 'translateX(0px)');
			}
		});

		var element = tl.find('.items')[0];
		new SwipeContent(element);
		element.addEventListener('swipeLeft', function () {
			$(nav).find('.next').trigger('click');
		});
		element.addEventListener('swipeRight', function () {
			$(nav).find('.prev').trigger('click');
		});

		// Equal height
		$(window)
			.on('resize', function () {
				var height = 0,
					tlHeight = 0;
				tl.find('.text').css('height', 'auto');
				tl.find('.item').each(function () {
					height = Math.max($(this).find('.text').height(), height);
					tlHeight = Math.max($(this).height(), tlHeight);
				});
				tl.find('.text').css('height', height);
				tl.find('.item-row').css('height', tlHeight);
			})
			.trigger('resize');
	});

	/**
	 * Steps scroller
	 */
	if ($('.steps').length) {
		$(window)
			.on('resize', function () {
				// Center vertically
				$('.steps .items').css(
					'top',
					(
						$('.steps .items').outerHeight() +
							$('.header').outerHeight() <
							$(window).height()
					) ?
						($(window).height() -
							$('.steps .items').outerHeight()) /
							2 -
							$('.header').outerHeight()
					:	0,
				);
			})
			.trigger('resize');

		$(window).on('scroll', function () {
			var top =
				$('.steps').offset().top +
				$('.steps .row:not(.item-row)').outerHeight();

			if ($(document).scrollTop() >= top) {
				var itemsWidth =
						$('.steps .item').outerWidth(true) *
							$('.steps .item').length +
						Math.max($(window).height(), $(window).width()),
					leftPos =
						$(document).scrollTop() -
						$('.steps .item-row').offset().top,
					headerHeight = $('.header').outerHeight();

				if ($('.steps .item.image').length) {
					itemsWidth += $('.steps .item').outerWidth(true);
				}

				$('.steps .pin')
					.addClass('fix')
					.css({
						top: headerHeight,
						height: 'calc(100vh - ' + headerHeight + 'px)',
					});
				$('.steps .items').css(
					'transform',
					'translateX(-' + leftPos + 'px)',
				);
				$('.steps .item-row').css(
					'height',
					itemsWidth - itemsWidth / 10,
				);
			}
			if ($(document).scrollTop() < top) {
				$('.steps .pin').removeClass('fix');
			}
		});
	}

	/**
	 * Video
	 */
	$('body').on('click', '[data-video]:not(.embedded)', function () {
		$(this)
			.html(
				(!$(this).hasClass('controls') ?
					'<div class="videoOverlay"></div>'
				:	'') +
					'<div class="videoWrapper">' +
					decodeURIComponent($(this).attr('data-video')).replace(
						/\+/g,
						' ',
					) +
					'</div>',
			)
			.addClass('embedded');
	});

	/**
	 * Intersection observer for handling header style
	 */
	$('body')
		.find('.block')
		.each(function () {
			if ('IntersectionObserver' in window) {
				var heroObserver = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							var header = $(entry.target).attr('data-header');
							if (
								typeof header !== 'undefined' &&
								header !== 'original'
							) {
								if (entry.isIntersecting) {
									$('.header').addClass('transparent');
									if (header === 'white') {
										$('.header').addClass('white');
									}
									if (header === 'dark') {
										$('.header').addClass('dark');
									}
									$('body').trigger('scroll');
								} else {
									$('.header').removeClass('transparent');
									if (header === 'white') {
										$('.header').removeClass('white');
									}
									if (header === 'dark') {
										$('.header').removeClass('dark');
									}
								}
							}
						});
					},
					{ rootMargin: '-3%' },
				);
				heroObserver.observe(this);
			}
		});

	/**
	 * Intersection observer for table row icon animation
	 */
	$('body')
		.find('.table tbody tr, .mobile-table dd')
		.each(function () {
			var observerElm = this;
			if ('IntersectionObserver' in window) {
				var trObserver = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								var i = 0;

								$(entry.target)
									.find('svg')
									.each(function () {
										toggleAni($(this), i);
										i++;
									});

								trObserver.unobserve(observerElm);
							}
						});
					},
					{ rootMargin: '-10%' },
				);
				trObserver.observe(this);
			} else {
				$(this).find('svg').addClass('ani');
			}
		});
	function toggleAni(item, i) {
		window.setTimeout(function () {
			item.addClass('ani');
		}, i * 50);
	}

	/**
	 * Intersection observer for animating numbers and charts
	 */
	$('body')
		.find(
			'.block.numbers span:not(.animate), .block.circle-charts .charts > div:not(.animated)',
		)
		.each(function () {
			var observerElm = this;
			if ('IntersectionObserver' in window) {
				var numbersObserver = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								if ($(entry.target).find('.circle').length) {
									$(entry.target)
										.addClass('animated')
										.find('.circle')
										.addClass('animate')
										.next()
										.counterUp({
											delay: 10,
											time: 1500,
											append: '%',
										});
								} else {
									$(entry.target)
										.addClass('animate')
										.counterUp({
											delay: 10,
											time: 1500,
										});
								}
								numbersObserver.unobserve(observerElm);
							}
						});
					},
					{ rootMargin: '-20%' },
				);
				numbersObserver.observe(this);
			}
		});

	/**
	 * Intersection observer for animating items into view
	 */
	$('body')
		.find('.animate')
		.each(function () {
			var observerElm = this;
			if ('IntersectionObserver' in window) {
				var animationObserver = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								$(observerElm).addClass('show');
								animationObserver.unobserve(observerElm);
							}
						});
					},
					{ rootMargin: '-10%' },
				);

				animationObserver.observe(this);
			}
		});

	/**
	 * Scroll event for header
	 */
	$(window).on('scroll', function () {
		$('body').toggleClass('scrolled', window.pageYOffset >= 50);

		// Fade out hero module
		//console.log($(window).scrollTop(), $('.hero').outerHeight(), Math.random());
		if (
			$('.hero').length &&
			$(window).scrollTop() < $('.hero').outerHeight()
		) {
			$('.hero .fade-out').css(
				'opacity',
				Math.min(
					1,
					0 + ($(window).scrollTop() / $('.hero').height()) * 2,
				),
			);
			$('.hero + .block').css(
				'margin-top',
				-(($(window).scrollTop() / $('.hero').height()) * 225),
			);

			/*if ($('.header').hasClass('white')) {
                $('.header svg path').css('fill', 'hsla(164,71%,11%,' + opacity + ')');
                //$('.header svg path').css('fill', 'hsl(164,71%,100%,' + opacity + ')');//hsla(164, 71%, 11%, 1)
            } else {
                //$('.header svg')
            }*/
		}

		// Make top white and transparent when footer is in view
		if (
			$(window).scrollTop() + $(window).height() >
				$(document).height() - $('.header').outerHeight() &&
			$(window).height() >= $('.footer').outerHeight()
		) {
			$('body').addClass('bottom');
			$('.header').addClass('transparent white');
		} else if ($('body').hasClass('bottom')) {
			$('.header').removeClass('transparent white');
			$('body').removeClass('bottom');
		}
		//$('.header').toggleClass('transparent white', $(window).scrollTop() + $(window).height() > $(document).height() - $('.header').outerHeight());
	});

	/**
	 * Lazy load images
	 */
	lazyLoad('body');
});

// Change background color on scroll
$(window)
	.on('scroll', function () {
		var scroll = window.pageYOffset + $(window).height() / 3;

		$('.block').each(function () {
			var $this = $(this),
				color = $this.attr('data-color'),
				defaultColor = 'rgba(255, 255, 255, ratio)';

			if (
				$this.position().top <= scroll &&
				$this.position().top + $this.height() > scroll
			) {
				if (color) {
					$('body, #headerBg').css(
						'background',
						color.replace('ratio', 1),
					);
				} else if (
					!$this.hasClass('footer') &&
					!($this.hasClass('hero') && $this.index() === 0)
				) {
					$('body, #headerBg').css(
						'background',
						defaultColor.replace('ratio', 1),
					);
				}
			}
		});
	})
	.trigger('scroll');

/**
 * Prevent body scroll and overscroll.
 * Tested on mac, iOS chrome / Safari, Android Chrome.
 *
 * Based on: https://benfrain.com/preventing-body-scroll-for-modals-in-ios/
 *           https://stackoverflow.com/a/41601290
 *
 * Use in combination with:
 * html, body {overflow: hidden;}
 *
 * and: -webkit-overflow-scrolling: touch; for the element that should scroll.
 *
 * disableBodyScroll(true, '.i-can-scroll');
 */
var disableBodyScroll = (function () {
	/**
	 * Private variables
	 */
	var _selector = false,
		_element = false,
		_clientY;

	/**
	 * Prevent default unless within _selector
	 *
	 * @param  event object event
	 * @return void
	 */
	var preventBodyScroll = function (event) {
		if (false === _element || !event.target.closest(_selector)) {
			event.preventDefault();
		}
	};

	/**
	 * Cache the clientY co-ordinates for
	 * comparison
	 *
	 * @param  event object event
	 * @return void
	 */
	var captureClientY = function (event) {
		// only respond to a single touch
		if (event.targetTouches.length === 1) {
			_clientY = event.targetTouches[0].clientY;
		}
	};

	/**
	 * Detect whether the element is at the top
	 * or the bottom of their scroll and prevent
	 * the user from scrolling beyond
	 *
	 * @param  event object event
	 * @return void
	 */
	var preventOverscroll = function (event) {
		// only respond to a single touch
		if (event.targetTouches.length !== 1) {
			return;
		}

		var clientY = event.targetTouches[0].clientY - _clientY;

		// The element at the top of its scroll,
		// and the user scrolls down
		if (_element.scrollTop === 0 && clientY > 0) {
			event.preventDefault();
		}

		// The element at the bottom of its scroll,
		// and the user scrolls up
		// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
		if (
			_element.scrollHeight - _element.scrollTop <=
				_element.clientHeight &&
			clientY < 0
		) {
			event.preventDefault();
		}
	};

	/**
	 * Disable body scroll. Scrolling with the selector is
	 * allowed if a selector is porvided.
	 *
	 * @param  boolean allow
	 * @param  string selector Selector to element to change scroll permission
	 * @return void
	 */
	return function (allow, selector) {
		if (typeof selector !== 'undefined') {
			_selector = selector;
			_element = document.querySelector(selector);
		}

		if (true === allow) {
			if (false !== _element && null !== _element) {
				_element.addEventListener('touchstart', captureClientY, false);
				_element.addEventListener(
					'touchmove',
					preventOverscroll,
					false,
				);
			}
			document.body.addEventListener(
				'touchmove',
				preventBodyScroll,
				false,
			);
		} else {
			if (false !== _element && null !== _element) {
				_element.removeEventListener(
					'touchstart',
					captureClientY,
					false,
				);
				_element.removeEventListener(
					'touchmove',
					preventOverscroll,
					false,
				);
			}
			document.body.removeEventListener(
				'touchmove',
				preventBodyScroll,
				false,
			);
		}
	};
})();

// File#: _1_swipe-content
(function () {
	var SwipeContent = function (element) {
		this.element = element;
		this.delta = [false, false];
		this.dragging = false;
		this.intervalId = false;
		initSwipeContent(this);
	};

	function initSwipeContent(content) {
		content.element.addEventListener(
			'mousedown',
			handleEvent.bind(content),
		);
		content.element.addEventListener(
			'touchstart',
			handleEvent.bind(content),
		);
	}

	function initDragging(content) {
		//add event listeners
		content.element.addEventListener(
			'mousemove',
			handleEvent.bind(content),
		);
		content.element.addEventListener(
			'touchmove',
			handleEvent.bind(content),
		);
		content.element.addEventListener('mouseup', handleEvent.bind(content));
		content.element.addEventListener(
			'mouseleave',
			handleEvent.bind(content),
		);
		content.element.addEventListener('touchend', handleEvent.bind(content));
	}

	function cancelDragging(content) {
		//remove event listeners
		if (content.intervalId) {
			!window.requestAnimationFrame ?
				clearInterval(content.intervalId)
			:	window.cancelAnimationFrame(content.intervalId);
			content.intervalId = false;
		}
		content.element.removeEventListener(
			'mousemove',
			handleEvent.bind(content),
		);
		content.element.removeEventListener(
			'touchmove',
			handleEvent.bind(content),
		);
		content.element.removeEventListener(
			'mouseup',
			handleEvent.bind(content),
		);
		content.element.removeEventListener(
			'mouseleave',
			handleEvent.bind(content),
		);
		content.element.removeEventListener(
			'touchend',
			handleEvent.bind(content),
		);
	}

	function handleEvent(event) {
		switch (event.type) {
			case 'mousedown':
			case 'touchstart':
				startDrag(this, event);
				break;
			case 'mousemove':
			case 'touchmove':
				drag(this, event);
				break;
			case 'mouseup':
			case 'mouseleave':
			case 'touchend':
				endDrag(this, event);
				break;
		}
	}

	function startDrag(content, event) {
		content.dragging = true;
		// listen to drag movements
		initDragging(content);
		content.delta = [
			parseInt(unify(event).clientX),
			parseInt(unify(event).clientY),
		];
		// emit drag start event
		emitSwipeEvents(content, 'dragStart', content.delta, event.target);
	}

	function endDrag(content, event) {
		cancelDragging(content);
		// credits: https://css-tricks.com/simple-swipe-with-vanilla-javascript/
		var dx = parseInt(unify(event).clientX),
			dy = parseInt(unify(event).clientY);

		// check if there was a left/right swipe
		if (content.delta && (content.delta[0] || content.delta[0] === 0)) {
			var s = getSign(dx - content.delta[0]);

			if (Math.abs(dx - content.delta[0]) > 30) {
				s < 0 ?
					emitSwipeEvents(content, 'swipeLeft', [dx, dy])
				:	emitSwipeEvents(content, 'swipeRight', [dx, dy]);
			}

			content.delta[0] = false;
		}
		// check if there was a top/bottom swipe
		if (content.delta && (content.delta[1] || content.delta[1] === 0)) {
			var y = getSign(dy - content.delta[1]);

			if (Math.abs(dy - content.delta[1]) > 30) {
				y < 0 ?
					emitSwipeEvents(content, 'swipeUp', [dx, dy])
				:	emitSwipeEvents(content, 'swipeDown', [dx, dy]);
			}

			content.delta[1] = false;
		}
		// emit drag end event
		emitSwipeEvents(content, 'dragEnd', [dx, dy]);
		content.dragging = false;
	}

	function drag(content, event) {
		if (!content.dragging) return;
		// emit dragging event with coordinates
		!window.requestAnimationFrame ?
			(content.intervalId = setTimeout(function () {
				emitDrag.bind(content, event);
			}, 250))
		:	(content.intervalId = window.requestAnimationFrame(
				emitDrag.bind(content, event),
			));
	}

	function emitDrag(event) {
		emitSwipeEvents(this, 'dragging', [
			parseInt(unify(event).clientX),
			parseInt(unify(event).clientY),
		]);
	}

	function unify(event) {
		// unify mouse and touch events
		return event.changedTouches ? event.changedTouches[0] : event;
	}

	function emitSwipeEvents(content, eventName, detail, el) {
		var trigger = false;
		if (el) trigger = el;
		// emit event with coordinates
		var event = new CustomEvent(eventName, {
			detail: { x: detail[0], y: detail[1], origin: trigger },
		});
		content.element.dispatchEvent(event);
	}

	function getSign(x) {
		if (!Math.sign) {
			return (x > 0) - (x < 0) || +x;
		} else {
			return Math.sign(x);
		}
	}

	window.SwipeContent = SwipeContent;

	//initialize the SwipeContent objects
	var swipe = document.getElementsByClassName('js-swipe-content');
	if (swipe.length > 0) {
		for (var i = 0; i < swipe.length; i++) {
			(function (i) {
				new SwipeContent(swipe[i]);
			})(i);
		}
	}
})();

/*!
 * jquery.counterup.js 1.0
 *
 * Copyright 2013, Benjamin Intal http://gambit.ph @bfintal
 * Released under the GPL v2 License
 *
 * Date: Nov 26, 2013
 */
(function ($) {
	'use strict';

	$.fn.counterUp = function (options) {
		// Defaults
		var settings = $.extend(
			{
				time: 400,
				delay: 10,
				comma: true,
				append: '',
			},
			options,
		);

		return this.each(function () {
			// Store the object
			var $this = $(this);
			var $settings = settings;

			var counterUpper = function () {
				var nums = [];
				var divisions = $settings.time / $settings.delay;
				var num = $this.text();
				num = num.replace(/,/g, '');
				var isFloat = /^[0-9]+\.[0-9]+$/.test(num);
				var decimalPlaces =
					isFloat ? (num.split('.')[1] || []).length : 0;

				// Generate list of incremental numbers to display
				for (var i = divisions; i >= 1; i--) {
					// Preserve as int if input was int
					var newNum = parseInt((num / divisions) * i);

					// Preserve float if input was float
					if (isFloat) {
						newNum = parseFloat((num / divisions) * i).toFixed(
							decimalPlaces,
						);
					}

					// Preserve commas if input had commas
					if ($settings.comma) {
						while (/(\d+)(\d{3})/.test(newNum.toString())) {
							newNum = newNum
								.toString()
								.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
						}
					}

					nums.unshift(newNum);
				}

				$this.data('counterup-nums', nums);
				$this.text('0');

				// Updates the number until we're done
				var f = function () {
					$this.text(
						$this.data('counterup-nums').shift() + $settings.append,
					);
					if ($this.data('counterup-nums').length) {
						setTimeout(
							$this.data('counterup-func'),
							$settings.delay,
						);
					} else {
						delete $this.data('counterup-nums');
						$this.data('counterup-nums', null);
						$this.data('counterup-func', null);
					}
				};
				$this.data('counterup-func', f);

				// Start the count up
				setTimeout($this.data('counterup-func'), $settings.delay);
			};

			counterUpper();
		});
	};
})(jQuery);

/**
 * Image preload function
 */
function imgPreload(imgs, callback) {
	'use strict';

	imgs =
		Object.prototype.toString.apply(imgs) === '[object Array]' ?
			imgs
		:	[imgs];

	var i,
		loaded = 0,
		images = [],
		inc = function () {
			loaded += 1;
			if (loaded === imgs.length && callback) {
				callback(images);
			}
		};

	for (i = 0; i < imgs.length; i++) {
		images[i] = new Image();
		images[i].onabort = inc;
		images[i].onerror = inc;
		images[i].onload = inc;
		images[i].src = imgs[i];
	}
}

/**
 * Lazy load images
 */
function lazyLoad(where) {
	$(where)
		.find('.lazy:not(.loaded):not(.hide)')
		.each(function () {
			var elm = $(this),
				observerElm = this,
				imgSrc = $(this).attr('data-img'),
				bgImgSrc = $(this).attr('data-bg-img'),
				video = $(this).attr('data-video'),
				type = imgSrc ? 'normal' : 'bg';

			if (imgSrc || bgImgSrc || video) {
				if (!video || (video && !elm.hasClass('autoplay'))) {
					imgSrc =
						type === 'bg' ?
							bgImgSrc.replace(/ /gi, '%20')
						:	imgSrc.replace(/ /gi, '%20');
				}

				if ('IntersectionObserver' in window) {
					var lazyImageObserver = new IntersectionObserver(function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								if (video && elm.hasClass('autoplay')) {
									elm.trigger('click').addClass('loaded');
									lazyImageObserver.unobserve(observerElm);
								} else {
									imgPreload(imgSrc, function () {
										if (type === 'bg') {
											elm.css(
												'background-image',
												(elm.hasClass('grayscale') ?
													'linear-gradient(black, black),'
												:	'') +
													'url(' +
													imgSrc +
													')',
											);
										} else {
											elm.attr('src', imgSrc);
										}
										elm.addClass('loaded');
										lazyImageObserver.unobserve(
											observerElm,
										);
									});
								}
							}
						});
					});

					lazyImageObserver.observe(this);
				} else {
					imgPreload(imgSrc, function () {
						if (type === 'bg') {
							elm.css(
								'background-image',
								(elm.hasClass('grayscale') ?
									'linear-gradient(black, black),'
								:	'') +
									'url(' +
									imgSrc +
									')',
							);
						} else {
							elm.attr('src', imgSrc);
						}
						elm.addClass('loaded');
					});
				}
			}
		});
}

// Detect clicks on checkboxes and their values
console.log('Checkboxes:');
$('body').on('click', 'input[type="checkbox"]', function () {
	$(this).parent().toggleClass('active');
	console.log($(this).val(), $(this).is(':checked'));
});
